<template>
  <div class="measurement-list">
    <MeasurementListItem
      v-for="(item, i) in measurementsList"
      :key="i"
      :index="i"
      :measurement="item"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMeasurementStore } from '@/store/measurementStore'
import { storeToRefs } from 'pinia'
import MeasurementListItem from '@/components/measurement/MeasurementListItem.vue'

const measurementStore = useMeasurementStore()
const { measurements } = storeToRefs(measurementStore)

const measurementsList = computed(() => {
  if (measurements.value.length <= 1) {
    return measurements.value
  }

  return measurements.value.slice(0, -1)
})
</script>

<style lang="scss">
.measurement-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background-color: var(--color-light);
  padding: 1.2rem;
  border-radius: 1.2rem;
  border: solid 1px var(--color-dark-10);
}
</style>
